export default __webpack_public_path__ + "static/media/other_pets.00b3c10b.svg";